import React, { useContext, useEffect, useState } from "react";
// import "./BudgetHead.css";
import Application from "../../StateContext/Application.js";
import {
  BudgetHeadCreationBlue32,
  Cancel32,
  DeleteRed32,
  EditBlueBlue32,
  submit,
  Tax32,
  UpdateWhite32,
  EditIcon,
  DeleteIcon,
  Edit32WHITE,
  Delete32WHITE,
  Approved32,
  SendBack32,
} from "../../../../public/LoginImages/importimages";
import { apiurl } from "../../../../path";
import CreateWorkOrder from "./CreateWorkOrder/CreateWorkOrder.js";

const WorkOrderInwardList = () => {
  const operation = useContext(Application);
  const {
    GetAllWorkOrderInward,
    BudgetHeadApproval,
    WorkManagementApproval,
    Usermenu,
  } = operation;

  const [WorkOrder, setWorkOrder] = useState([]);
  const [loading, setLoading] = useState(false);
  const [SelectedOptions, setSelectedOptions] = useState("Pending");
  const [selectedBills, setSelectedBills] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
  const [rejectPanelhide, setRejectpanelhide] = useState(1);
  const [remark, setRemark] = useState("");

  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
  console.log("currentbills", currentBills);
  const tableHeadStyle = {
    padding: "14px 12px",
    textAlign: "center",
    fontWeight: "700",
    whiteSpace: "nowrap",
  };

  const tableBodyStyle = {
    padding: "14px 12px",
    textAlign: "center",
    borderBottom: "1px solid #e5e7eb",
    fontSize: "13px",
    color: "#374151",
  };
  const [showEditForm, setShowEditForm] = useState(false);
  const [editProjectData, setEditProjectData] = useState(null);
  const [menuData, setMenuData] = useState({});
  const [editData, setEditData] = useState({});
  const [openEdit, setOpenEdit] = useState(false);

  useEffect(() => {
    FetchWorkOrderList();
  }, []);

  // const FetchWorkOrderList = async () => {
  //   try {
  //     let res = await GetAllWorkOrderInward();

  //     console.log("res", res);

  //     setFilteredBills(res || []);
  //     setWorkOrder(res || []);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  const FetchWorkOrderList = async () => {
    try {
      let res = await GetAllWorkOrderInward();

      console.log("res", res);

      const data = res || [];

      // Latest added record first
      const latestFirst = [...data].reverse();

      setFilteredBills(latestFirst);
      setWorkOrder(latestFirst);
      setCurrentPage(1);
    } catch (err) {
      console.log(err);
    }
  }; //04/09/2026

  const handleCheckboxChange = (id) => {
    setSelectedBills((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((billId) => billId !== id)
        : [...prevSelected, id],
    );
  };

  console.log("Slected id form table :: ", selectedBills);
  console.log("Filtered data id form table :: ", filteredBills);

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedBills(currentBills.map((bill) => bill.WorkOrderID));
    } else {
      setSelectedBills([]);
    }
  };

  const approveorrejectSelected = async (condition) => {
    if (selectedBills.length === 0) {
      alert("No Budget Head selected for approval!");
      return;
    }
    console.log(selectedBills);
    setLoading(true);
    let shouldStart = window.confirm("Are you sure ???");

    if (shouldStart) {
      try {
        let response = await WorkManagementApproval(
          selectedBills,
          condition,
          remark,
        );
        if (response.message) {
          alert(response.message);
          setRejectpanelhide(0);
          setRemark("");
          setLoading(false);
          window.location.reload();
        }
        if (response.error) {
          alert(response.error);
          setRejectpanelhide(0);
          setRemark("");
          setLoading(false);
          window.location.reload();
        }
      } catch (error) {
        console.error("Error approving Proposal:", error);
        alert("An error occurred while approving bills.");
        setRejectpanelhide(0);
        setLoading(false);
        setRemark("");
        window.location.reload();
      }
    } else {
      alert(`Budget Head ${condition} Operation Cancelled !!!`);
      setRemark("");
      setRejectpanelhide(0);
      window.location.reload();
    }
    setLoading(false); // Stop loader
  };

  const rejectSendbackbeforecheckup = (id) => {
    if (selectedBills.length > 0) {
      setRejectpanelhide(id);
    } else {
      alert("No Bill Selected !!!");
    }
  };

  useEffect(() => {
    const getMenu = async () => {
      const res = await Usermenu();
      console.log(res);
      setMenuData(res.Data);
    };

    getMenu();
  }, []);
  const isChecker =
    menuData?.Department_Name === "New Agency Checker" &&
    menuData?.Role === "New Agency Checker";

  const isMaker =
    menuData?.Department_Name === "New Agency Maker" &&
    menuData?.Role === "New Agency Maker";
  console.log("menuData", menuData);

  const handleEditProject = async () => {
    if (selectedBills.length !== 1) {
      alert("Please select exactly one project to edit.");
      return;
    }
    try {
      // const selectedProjectId = selectedBills[0];
      // const res = await GetBudgetHeadInfo(selectedProjectId, "id");
      // setEditProjectData(res[0]);
      const selectedWorkOrder = filteredBills.find(
        (item) => item.WorkOrderID === selectedBills[0],
      );
      setEditData(selectedWorkOrder);
      setOpenEdit(true);
      setShowEditForm(true); // Hide table and show form
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    const filtered = WorkOrder.filter((item) => {
      const term = searchTerm.toLowerCase();
      return (
        item?.FinancialYear?.toLowerCase().includes(term) ||
        item?.ProjectID?.toString().toLowerCase().includes(term) ||
        item?.ProjectName?.toLowerCase().includes(term) ||
        item?.ContractorName?.toLowerCase().includes(term) ||
        item?.WorkName?.toLowerCase().includes(term) ||
        item?.WorkOrderNo?.toLowerCase().includes(term) ||
        item?.ApprovedWorkAmount?.toLowerCase().includes(term) ||
        item?.RemainingAmount?.toLowerCase().includes(term) ||
        item?.PaidAmount?.toLowerCase().includes(term)
      );
    });
    setFilteredBills(filtered);
    setCurrentPage(1);
    // Reset to first page after search
  }, [searchTerm, WorkOrder]);

  const getPageNumbers = () => {
    const maxVisiblePages = 5;

    // Total pages 5
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Page 1, 2, 3 par
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };

  return (
    <>
      <div
         style={{
    background: openEdit ? "#ffffff" : "#EEF2F7",   
    border: "1px solid #dfe5ee",
    borderRadius: "10px",
    margin: "15px 20px",
    padding: "15px 20px 20px",
    boxSizing: "border-box",
    minWidth: 0,
    position: "relative",
  }}
      >
        {/* <div
          style={{
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            backgroundColor: "#ffffff",
            boxSizing: "border-box",
            position: "relative",
          }}
        > */}
        <div
            style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            maxWidth: "100%",
            minWidth: 0,
            //29/10
            // padding: "20px",
            marginBottom: "15px",
            boxSizing: "border-box",
          }}
        >
          <h5 className="my-auto fw-bold">
            {/* <img src="/GR-Approval64.png" alt="Technical Approval" style={{ width: "24px", height: "24px" }} className='my-auto me-1' /> */}
            <img
    src="/Project-Inward-List-32.png"
    alt="img"
   
  />
            <span className="my-auto">Work Order Inward List</span>
          </h5>

          <div
            style={{
              position: "relative",
              width: "250px",
              maxWidth: "250px",
              minWidth: 0,
              flexShrink: 1,
              margin: "0",
              boxSizing: "border-box",
            }}
          >
            <img
              src="/Search32.png"
              alt="Search Icon"
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                width: "16px",
                height: "16px",
                opacity: 0.6,
              }}
            />
            <input
              type="text"
              placeholder="Search Here"
              onChange={(e) => setSearchTerm(e.target.value)}
              value={searchTerm}
              style={{
                width: "100%",
                padding: "8px 12px 8px 32px", // left padding makes space for icon
                border: "1px solid #ccc",
                borderRadius: "8px",
                backgroundColor: "White",
                fontSize: "14px",
                color: "#333",
                boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
                outline: "none",
              }}
            />
          </div>
        </div>

        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255, 255, 255, 0.7)",
              backdropFilter: "blur(4px)",
              zIndex: 9999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
               style={{
                border: "6px solid #f3f3f3",
                borderTop: "6px solid #007bff",
                borderRadius: "50%",
                width: "60px",
                height: "60px",
                animation: "spin 1s linear infinite",
              }}
            />
            <style>
              {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
            </style>
          </div>
        )}
        <>
          {!openEdit && (
            <div
              className="m-auto mb-3"
             style={{
    backgroundColor: "#ffffff",
    padding: "15px 20px 5px",
    border: "1px solid #e1e6ee",
    borderRadius: "16px",
    width: "100%",
    boxSizing: "border-box",
    overflow: "hidden",
  }}
            >
              <div
               style={{
    overflowX: "auto",
    width: "100%",
    border: "1px solid #d9e1f2",   
    borderRadius: "8px",           
    boxSizing: "border-box",
  }}
>
              
                {SelectedOptions === "Pending" && (
                  <table
                    className="m-0 p-0"
                     style={{
      backgroundColor: "white",
      width: "100%",
      minWidth: "70vw",
      borderCollapse: "separate", 
      borderSpacing: 0,            
    }}
                  >
                    <thead>
                      <tr
                         //28/10
                        style={{
                          backgroundColor: "#2D79D9",
                          color: "white",
                          border: "none",
                          height: "36px",
                          fontSize: "14px",
                          fontWeight: "600",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <th style={{ minWidth: "50px", padding: "8px" }}>
                          <input
                            type="checkbox"
                            onChange={handleSelectAll}
                            checked={
                              selectedBills.length === currentBills.length
                            }
                            className="my-auto"
                            style={{ height: "1rem", width: "1rem" }}
                          />
                        </th>
                        <th style={{ padding: "8px 10px" }}>Sr.No</th>
                        <th style={{ padding: "8px 10px" }}>Financial Year</th>
                        <th style={{ padding: "8px 10px" }}>Project ID</th>
                        <th style={{ padding: "8px 10px" }}>Project Name</th>
                        <th style={{ padding: "8px 10px" }}>Project Cost</th>
                        <th style={{ padding: "8px 10px" }}>GRCopy</th>
                        {/* <th style={{ padding: "10px" }}>CRC</th>
                                                <th style={{ padding: "10px" }}>Budget Head</th> */}
                        <th style={{ padding: "8px 10px" }}>Vendor Name</th>
                        <th style={{ padding: "8px 10px" }}>Work Name</th>
                        <th style={{ padding: "8px 10px" }}>Work Order No</th>
                        <th style={{ padding: "8px 10px" }}>Work Order Date</th>
                        <th style={{ padding: "8px 10px" }}>Work End Date</th>
                        <th style={{ padding: "8px 10px" }}>
                          Approved Work Amount
                        </th>
                        <th style={{ padding: "8px 10px" }}>Paid Amount</th>
                        <th style={{ padding: "8px 10px" }}>
                          Remaining Amount
                        </th>
                        <th style={{ padding: "8px 10px" }}>
                          Copy of Work Order
                        </th>
                        <th style={{ padding: "8px 10px" }}>Creation Date</th>
                        {isMaker && (
                          <th style={{ padding: "8px 10px" }}>Remark</th>
                        )}
                        {isMaker && (
                          <th style={{ padding: "8px 10px" }}>Action</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {currentBills.length <= 0 ? (
                        <tr>
                          {/* <td
                            colSpan="17"
                            style={{
                              textAlign: "center",
                              padding: "15px 10px",
                              backgroundColor: "#f9f9f9",
                            }}
                          >
                            No data available
                          </td> */}
                        </tr>
                      ) : (
                        currentBills?.map((workorder, index) => {
                           const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CEE4F1";
                          return (
                            <tr
                              style={{
                                backgroundColor: bgColor,
                                fontSize: "12px",
                                fontWeight: "500",
                              }}
                              key={index}
                            >
                              <td style={{ textAlign: "center" }}>
                                <input
                                  type="checkbox"
                                  className="my-auto"
                                  style={{ height: "1rem", width: "1rem" }}
                                  checked={selectedBills.includes(
                                    workorder.WorkOrderID,
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(workorder.WorkOrderID)
                                  }
                                />
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {indexOfFirstBill + index + 1}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {workorder.FinancialYear}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                   color: "rgb(82, 149, 201)",textAlign:"center"
                                }}
                              >
                                {workorder.ProjectID}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {workorder.ProjectName}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {/* {workorder.ProjectCost} */}
                                {Number(
                                  workorder.ProjectCost || 0,
                                ).toLocaleString("en-IN")}
                              </td>
                              <td
                                                  style={{padding: "8px", minWidth: "160px", width: "160px",maxWidth: "160px",  whiteSpace: "nowrap",  textAlign: "center"}} >
                                                  <a
                                                    href={`${apiurl}/ProjectDocsImages/${workorder.GRCopy}`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                     title={workorder.GRCopy}   // 🔵 full filename shown on hover
                                                                        style={{
                                                                          display: "flex",
                                                                          alignItems: "center",
                                                                          justifyContent: "center",
                                                                          gap: "5px",
                                                                          width: "100%",
                                                                          overflow: "hidden",
                                                                          textDecoration: "none",
                                                                          color: "#0d6efd",
                                                                        }}
                                                  >
                                                    {/* {workorder.GRCopy} */}
                                                    {workorder.ProjectID} GR Copy 
                                                  </a>
                                                </td>
                              {/* <td style={{ padding: "10px" }}>{workorder.CRC}</td>
                                                                    <td style={{ padding: "10px" }}>{workorder.BudgetHead}</td> */}
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {workorder.ContractorName}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {workorder.WorkName}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {workorder.WorkOrderNo}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {workorder.WorkOrderDate?.split("T")[0]}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {workorder.WorkEndDate?.split("T")[0]}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {/* {workorder.ApprovedWorkAmount} */}₹
                                {Number(
                                  workorder.ApprovedWorkAmount || 0,
                                ).toLocaleString("en-IN")}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {/* {workorder.PaidAmount} */}₹
                                {Number(
                                  workorder.PaidAmount || 0,
                                ).toLocaleString("en-IN")}
                              </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {/* {workorder.RemainingAmount} */}₹
                                {Number(
                                  workorder.RemainingAmount || 0,
                                ).toLocaleString("en-IN")}
                              </td>
                              <td
                                                 style={{ padding: "8px", minWidth: "160px",width: "160px", maxWidth: "160px", whiteSpace: "nowrap", textAlign: "center", }}  >
                                                 <a
                                                   href={`${apiurl}/WorkOrderDocsImages/${workorder.CopyofWorkOrder}`}
                                                   target="_blank"
                                                   rel="noreferrer"
                                                   title={workorder.CopyofWorkOrder}   // 🔵 full filename shown on hover
                                                                       style={{
                                                                         display: "flex",
                                                                         alignItems: "center",
                                                                         justifyContent: "center",
                                                                         gap: "5px",
                                                                         width: "100%",
                                                                         overflow: "hidden",
                                                                         textDecoration: "none",
                                                                         color: "#0d6efd",
                                                                       }}
                                                 > 
                                                   {/* {workorder.CopyofWorkOrder} */}
                                                   {workorder.WorkOrderID}CopyOfWorkOrder
                                                 </a>
                                               </td>
                              <td
                                style={{
                                  padding: "8px 10px",
                                  height: "40px",
                                  verticalAlign: "middle",
                                  textAlign: "center",
                                }}
                              >
                                {workorder.Date?.split("T")[0]}
                              </td>

                              {isMaker && (
                                <td
                                  style={{
                                    padding: "8px 10px",
                                    height: "40px",
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  {workorder.remark}
                                </td>
                              )}
                              {isMaker && (
                                <td
                                  style={{
                                    padding: "8px 10px",
                                    height: "40px",
                                    verticalAlign: "middle",
                                    textAlign: "center",
                                  }}
                                >
                                  <button
                                    onClick={() => {
                                      setEditData(workorder);
                                      setOpenEdit(true);
                                    }}
                                    disabled={
                                      !selectedBills.includes(
                                        workorder.WorkOrderID,
                                      ) || loading
                                    }
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "5px",
                                      margin: "auto",
                                      padding: "6px 12px",
                                      background: selectedBills.includes(
                                        workorder.WorkOrderID,
                                      )
                                        ? "#0D6EFD"
                                        : "rgba(141,141,141,0.97)",
                                      color: "#fff",
                                      border: "none",
                                      borderRadius: "6px",
                                      fontSize: "13px",
                                      fontWeight: "600",
                                      cursor: selectedBills.includes(
                                        workorder.WorkOrderID,
                                      )
                                        ? "not-allowed"
                                        : "pointer",
                                    }}
                                  >
                                    <img
                                      src={Edit32WHITE}
                                      alt="Edit"
                                      style={{
                                        width: "14px",
                                        height: "14px",
                                      }}
                                    />
                                    Edit
                                  </button>
                                </td>
                              )}
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                  
                )}
                {/* 29-09 */}
                     {(!Array.isArray(currentBills) || currentBills.length === 0) && (
                        <div
                            style={{
                                position: "sticky",
                                left: 0,
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "150px",
                                boxSizing: "border-box",
                                backgroundColor: "#ffffff",
                                color: "#333",
                                fontSize: "14px",
                                fontWeight: 500,
                            }}
                        >
                            No data available
                        </div>
                    )}
              </div>

              <div className="col-12 mt-3">
                <div className="row">
                  <div
                    className="col-6 text-start"
                    style={{ display: "flex", justifyContent: "left" }}
                  >
                    <button
                      onClick={() => approveorrejectSelected("Approved")}
                      disabled={selectedBills.length <= 0 ? true : loading}
                      className="ms-0"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "0.3rem",
                        margin: "12px",
                        padding: "8px 10px",
                        fontWeight: "600",
                        backgroundColor:
                          selectedBills.length <= 0 ? "#f3eeee" : "#39B54A",

                        color: selectedBills.length > 0 ? "#ffffff" : "#01B574",

                        border: "1px solid #39B54A",
                        borderRadius: "8px",
                        cursor:
                          selectedBills.length <= 0
                            ? "not-allowed"
                            : loading
                              ? "not-allowed"
                              : "pointer",
                      }}
                    >
                      <img
                        src={Approved32}
                        alt="Approve"
                        style={{
                          width: "18px",
                          height: "18px",
                        }}
                      />

                      {loading ? "Processing..." : "Approve Selected"}
                    </button>

                    {isChecker && (
                      <button
                        onClick={() => rejectSendbackbeforecheckup(2)}
                        disabled={selectedBills.length <= 0 ? true : loading}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.3rem",
                          margin: "12px",
                          padding: "8px 10px",
                          fontWeight: "600",
                          backgroundColor:
                            selectedBills.length <= 0 ? "#f3eeee" : "#C1272D",

                          color: selectedBills.length > 0 ? "#ffffff" : "red",

                          border: "1px solid #ff6b81",
                          borderRadius: "8px",
                          cursor:
                            selectedBills.length <= 0
                              ? "not-allowed"
                              : loading
                                ? "not-allowed"
                                : "pointer",
                        }}
                      >
                        <img
                          src={DeleteRed32}
                          alt="Reject"
                          style={{
                            width: "18px",
                            height: "18px",
                            filter:
                              selectedBills.length > 0
                                ? "brightness(0) invert(1)"
                                : "none",
                          }}
                        />

                        {loading ? "Processing..." : "Reject Selected"}
                      </button>
                    )}

                    {isChecker && (
                      <button
                        onClick={() => rejectSendbackbeforecheckup(3)}
                        disabled={selectedBills.length <= 0 || loading}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "3px",
                          margin: "12px",
                          padding: "8px 10px",
                          fontWeight: "600",
                          backgroundColor:
                            selectedBills.length <= 0 ? "#f3eeee" : "#0d6efd",

                          color:
                            selectedBills.length > 0 ? "#ffffff" : "#0d6efd",

                          border: "1px solid #0d6efd",

                          borderRadius: "8px",
                          cursor:
                            selectedBills.length <= 0 || loading
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        <img
                          src={SendBack32}
                          alt="Send Back"
                          style={{
                            width: "18px",
                            height: "18px",
                            flexShrink: 0,
                            filter:
                              selectedBills.length > 0
                                ? "brightness(0) invert(1)"
                                : "invert(28%) sepia(99%) saturate(7486%) hue-rotate(230deg) brightness(89%) contrast(128%)",
                          }}
                        />
                        {loading ? "Processing..." : "Send Back Selected"}
                      </button>
                    )}
                  </div>

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginTop: "15px",
                      padding: "10px 5px",
                      boxSizing: "border-box",
                    }}
                  >
                    {/* Showing Entries */}
                    <div
                      style={{
                        fontSize: "13px",
                        color: "#333",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Showing{" "}
                      {filteredBills.length === 0 ? 0 : indexOfFirstBill + 1} to{" "}
                      {Math.min(indexOfLastBill, filteredBills.length)} of{" "}
                      {filteredBills.length} entries
                    </div>

                    {/* Pagination */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "20px",
                      }}
                    >
                      {/* Previous */}
                      <button
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                        style={{
                          border: "none",
                          background: "transparent",
                          color: currentPage === 1 ? "#999" : "#2ea4e7",
                          cursor: currentPage === 1 ? "not-allowed" : "pointer",
                          fontSize: "13px",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          opacity: currentPage === 1 ? 0.5 : 1,
                        }}
                      >
                        <span style={{ fontSize: "18px" }}>‹</span>
                        Previous
                      </button>

                      {/* Page Numbers */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "20px",
                        }}
                      >
                        {getPageNumbers(currentPage, totalPages).map(
                          (pageNumber) => (
                            <button
                              key={pageNumber}
                              onClick={() => setCurrentPage(pageNumber)}
                              style={{
                                border: "none",
                                background: "transparent",
                                padding: 0,
                                color:
                                  currentPage === pageNumber
                                    ? "#2ea4e7"
                                    : "#444",
                                cursor: "pointer",
                                fontSize: "13px",
                                fontWeight:
                                  currentPage === pageNumber ? "600" : "400",
                                textDecoration:
                                  currentPage === pageNumber
                                    ? "underline"
                                    : "none",
                              }}
                            >
                              {pageNumber}
                            </button>
                          ),
                        )}
                      </div>

                      {/* Next */}
                      <button
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages),
                          )
                        }
                        disabled={
                          currentPage === totalPages || totalPages === 0
                        }
                        style={{
                          border: "none",
                          background: "transparent",
                          color:
                            currentPage === totalPages || totalPages === 0
                              ? "#999"
                              : "#2ea4e7",
                          cursor:
                            currentPage === totalPages || totalPages === 0
                              ? "not-allowed"
                              : "pointer",
                          fontSize: "13px",
                          padding: 0,
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                          opacity:
                            currentPage === totalPages || totalPages === 0
                              ? 0.5
                              : 1,
                        }}
                      >
                        Next
                        <span style={{ fontSize: "18px" }}>›</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {openEdit && (
            <div
              style={{
                width: "100%",
                padding: "20px",
                background: "#f5f7fb",
                minHeight: "100vh",
              }}
            >
              {/* Back Button */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "15px",
                }}
              >
                <button
                  onClick={() => {
                    setOpenEdit(false);
                    setEditData(null);
                  }}
                  style={{
                    background: "#0d6efd",
                    color: "#fff",
                    border: "none",
                    padding: "10px 18px",
                    borderRadius: "8px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  ← Back
                </button>
              </div>

              {/* Update Form */}

              <CreateWorkOrder
                isEdit={true}
                projectDatainward={editData}
                onSuccess={() => {
                  setOpenEdit(false);
                  setEditData(null);
                  FetchWorkOrderList();
                  setSelectedBills([]);
                }}
                onCancel={() => {
                  setOpenEdit(false);
                  setEditData(null);
                }}
              />
            </div>
          )}
        </>
      </div>
      {/* </div> */}

      {rejectPanelhide === 2 && (
        <div
          className="col-12 RejectPanelContainer"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="Rejectpanel"
            style={{
              width: "500px",
              background: "#fff",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 0 15px rgba(0,0,0,0.2)",
            }}
          >
            <form action="">
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label className="fw-bold">
                      Remark <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-8">
                    <textarea
                      name=""
                      id=""
                      placeholder="Enter Remark"
                      onChange={(e) => setRemark(e.target.value)}
                    ></textarea>
                  </div>
                </div>
              </div>
            </form>
            <div className="col-12 ms-auto my-4">
              <div className="row">
                {/* <div className="col-3"></div> */}
                <div className="col-9 m-auto">
                  <div
                    className="col-12"
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        background:
                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                        width: "5rem",
                        height: "2rem",
                        fontSize: "18px",
                      }}
                      onClick={() => approveorrejectSelected("Rejected")}
                    >
                      <img src={submit} style={{ width: "15px" }} /> Reject
                    </button>
                    <button
                      type="button"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        backgroundColor: "#f1594c",
                        width: "6rem",
                        height: "2rem",
                        fontSize: "16px",
                      }}
                      onClick={() => window.location.reload()}
                    >
                      {" "}
                      <img src={Cancel32} style={{ width: "17px" }} />
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {rejectPanelhide === 3 && (
        <div
          className="col-12 RejectPanelContainer"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            className="Rejectpanel"
            style={{
              width: "500px",
              background: "#fff",
              borderRadius: "10px",
              padding: "20px",
              boxShadow: "0 0 15px rgba(0,0,0,0.2)",
            }}
          >
            <form action="">
              <div className="col-12 elements">
                <div className="row">
                  <div className="col-3">
                    <label className="fw-bold">
                      Remark <span className="text-danger">*</span>
                    </label>
                  </div>
                  <div className="col-8">
                    <textarea
                      name=""
                      id=""
                      placeholder="Enter Remark"
                      onChange={(e) => setRemark(e.target.value)}
                    ></textarea>
                  </div>
                </div>
              </div>
            </form>
            <div className="col-12 ms-auto my-4">
              <div className="row">
                {/* <div className="col-3"></div> */}
                <div className="col-9 m-auto">
                  <div
                    className="col-12"
                    style={{
                      display: "flex",
                      gap: "10px",
                      justifyContent: "center",
                    }}
                  >
                    <button
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        background:
                          "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                        width: "8rem",
                        height: "2rem",
                        fontSize: "18px",
                      }}
                      onClick={() => approveorrejectSelected("SendBack")}
                    >
                      <img src={submit} style={{ width: "15px" }} /> Send Back
                    </button>
                    <button
                      type="button"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "4px",
                        backgroundColor: "#f1594c",
                        width: "6rem",
                        height: "2rem",
                        fontSize: "16px",
                      }}
                      onClick={() => window.location.reload()}
                    >
                      {" "}
                      <img src={Cancel32} style={{ width: "17px" }} />
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WorkOrderInwardList;
